// Operator display order for consistent sorting
export const OPERATOR_DISPLAY_ORDER = ['OPL', 'TMPL', 'PLK', 'P4']

// Backend to frontend code mapping
export const BACKEND_TO_FRONTEND_CODE = {
  'ORANGE': 'OPL',
  'TMOBILE': 'TMPL',
  'PLUS': 'PLK',
  'PLAY': 'P4',
  'P4': 'P4'
}

// Backend to standard code mapping
export const BACKEND_TO_STANDARD = {
  'ORANGE': 'ORANGE',
  'OPL': 'ORANGE',
  'TMOBILE': 'TMOBILE',
  'TMPL': 'TMOBILE',
  'PLUS': 'PLUS',
  'PLK': 'PLUS',
  'PLAY': 'P4',
  'P4': 'P4'
}

// Display name to backend code mapping
export const DISPLAY_TO_BACKEND = {
  'Orange': 'ORANGE',
  'T-Mobile': 'TMOBILE',
  'Plus': 'PLUS',
  'Play': 'P4'
}

// Operator display information (name, colors)
export const OPERATOR_INFO = {
  'OPL': { 
    display_name: 'Orange', 
    color: '#F97316',
    bgLight: 'bg-orange-50',
    bgHover: 'hover:bg-orange-50/30',
    borderColor: 'border-orange-500',
    textColor: 'text-orange-500'
  },
  'TMPL': { 
    display_name: 'T-Mobile', 
    color: '#E20074',
    bgLight: 'bg-pink-50',
    bgHover: 'hover:bg-pink-50/30',
    borderColor: 'border-pink-500',
    textColor: 'text-pink-500'
  },
  'PLK': { 
    display_name: 'Plus', 
    color: '#10B981',
    bgLight: 'bg-green-50',
    bgHover: 'hover:bg-green-50/30',
    borderColor: 'border-green-500',
    textColor: 'text-green-500'
  },
  'P4': { 
    display_name: 'Play', 
    color: '#8B5CF6',
    bgLight: 'bg-purple-50',
    bgHover: 'hover:bg-purple-50/30',
    borderColor: 'border-purple-500',
    textColor: 'text-purple-500'
  },
  // Also map backend codes
  'ORANGE': { 
    display_name: 'Orange', 
    color: '#F97316',
    bgLight: 'bg-orange-50',
    bgHover: 'hover:bg-orange-50/30',
    borderColor: 'border-orange-500',
    textColor: 'text-orange-500'
  },
  'TMOBILE': { 
    display_name: 'T-Mobile', 
    color: '#E20074',
    bgLight: 'bg-pink-50',
    bgHover: 'hover:bg-pink-50/30',
    borderColor: 'border-pink-500',
    textColor: 'text-pink-500'
  },
  'PLUS': { 
    display_name: 'Plus', 
    color: '#10B981',
    bgLight: 'bg-green-50',
    bgHover: 'hover:bg-green-50/30',
    borderColor: 'border-green-500',
    textColor: 'text-green-500'
  },
  'PLAY': { 
    display_name: 'Play', 
    color: '#8B5CF6',
    bgLight: 'bg-purple-50',
    bgHover: 'hover:bg-purple-50/30',
    borderColor: 'border-purple-500',
    textColor: 'text-purple-500'
  }
}

// Helper to get operator info with fallback
export const getOperatorInfo = (opCode) => {
  return OPERATOR_INFO[opCode] || { 
    display_name: opCode, 
    color: '#6b7280',
    bgLight: 'bg-gray-50',
    bgHover: 'hover:bg-gray-50/30',
    borderColor: 'border-gray-500',
    textColor: 'text-gray-500'
  }
}

// Name variations for goal matching
export const NAME_VARIATIONS = {
  'BARTOSZ': 'BARTEK',
  'PIOTR': 'PIOTREK',
  'MIROSŁAW': 'MIREK',
  'MIROSLAV': 'MIREK',
  'AGNIESZKA': 'AGA'
}

// Month names in Polish
export const MONTH_NAMES = [
  'Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
  'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
]

// Available years for selection
export const AVAILABLE_YEARS = [2024, 2025, 2026]


